<template>
<div ref="body">
    <base-header v-once pageName="고객등록" :prevBtnShow="true" history="main"></base-header>
    
    <section id="wrap" :class="{move : move}">        
        <div class="swiper slideMenu cusReg" :class="{move : move}" v-swiper:myDirectiveSwiper="slideMenu" ref="slide">
            <div class="swiper-wrapper" ref="tabObj">
                <div class="swiper-slide" :style="{order:cardSort['CRS02']}"><em @click="focus('1')" :class="{ current: tabActive == cardSort['CRS02'] }">인증정보</em></div>
                <div class="swiper-slide" :style="{order:cardSort['CRS03']}"><em @click="focus('2')" :class="{ current: tabActive == cardSort['CRS03'] }">자녀정보</em></div>
                <div class="swiper-slide" :style="{order:cardSort['CRS04']}"><em @click="focus('3')" :class="{ current: tabActive == cardSort['CRS04'] }">메모</em></div>
                <div class="swiper-slide" :style="{order:cardSort['CRS05']}"><em @click="focus('4')" :class="{ current: tabActive == cardSort['CRS05'] }">부모정보</em></div>
                <div class="swiper-slide" :style="{order:cardSort['CRS06']}"><em @click="focus('5')" :class="{ current: tabActive == cardSort['CRS06'] }">관심정보</em></div>
                <div class="swiper-slide" :style="{order:cardSort['CRS01']}"><em @click="focus('6')" :class="{ current: tabActive == cardSort['CRS01'] }">무진활동</em></div>
            </div>
        </div>
        
        <div class="customer-register">
                
            <!--figure>
                <a @click="goBannerPage"><img src="../../assets/images/temp_edu.svg" alt=""></a>
            </figure-->

            <div class="wrap" id="pos01" ref="pos01" :style="{order:cardSort['CRS02']}">
                <button type="button">인증정보</button>
                <div>
                    <div class="sub">
                        <dl>
                            <dt class="req">휴대폰번호</dt>
                            <dd>
                                <input type="tel" ref="custhno" id="custhno" :value="custInfo.custhno" v-on:input="checkText($event)" @keyup="checkVal" @blur="regDulCheck" placeholder='"-" 제외하고 입력해주세요. (예 : 01012345678)'>
                                <span class="number pass" v-if="regDulCount == 0">등록 가능한 번호입니다.</span><span class="number have" v-if="regDulCount > 0">이미 등록된 번호입니다. </span>
                            </dd>
                            <dt class="req">이름</dt>
                            <dd><input type="text" ref='custname' id='custname' :value="custInfo.custname" v-on:input="checkText($event)" placeholder="이름을 입력해주세요."></dd>
                            <dt>인증방식을 선택해주세요.</dt>
                            <dd class="flex-between btn">
                                <button type="button" @click.prevent="termsView" v-if="!validAuthYn">인증하기</button>
                                <button type="button" @click="sendAuthMMS" v-if="!validAuthYn">인증문자보내기</button>
                                <span v-if="validAuthYn">인증완료</span>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
            <div class="wrap" id="pos02" ref="pos02" :style="{order:cardSort['CRS03']}">
                <button type="button">* 자녀정보</button>
                <div>
                    <p class="info">최대 5명까지 등록 가능</p>
                    <div class="sub">
                        <h6>자녀1</h6>
                        <dl class="child">
                            <dt>성별을 선택해주세요.</dt>
                            <dd class="flex-between">
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr1" value="M" id="male-1"  @keyup="checkVal">
                                    <label for="male-1">남</label>
                                </span>
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr1" value="F" id="female-1"  @keyup="checkVal">
                                    <label for="female-1">여</label>
                                </span>
                            </dd>
                            <dt>생년월일을 입력해주세요. <span>(예: 20150101)</span></dt>
                            <dd>
                                <input type="tel" ref="chlnbdt1" id="chlnbdt1" :value="custInfo.chlnbdt1" v-on:input="checkText($event)" placeholder="8자리를 입력해주세요. (예 : 20150101)"  @keyup="checkVal">
                                <input type="text" ref="age1" disabled>
                            </dd>
                            <dt>이름</dt>
                            <dd><input type="text" ref="chlnnam1" id="chlnnam1" :value="custInfo.chlnnam1" v-on:input="checkText($event)" placeholder="자녀 이름을 입력해주세요."></dd>
                            <!-- <dt>학교</dt>
                            <dd><input type="text"  placeholder="학교명을 입력해주세요."></dd> -->
                        </dl>
                    </div>
                    <div class="sub" v-if="child2">
                        <h6>자녀2</h6>
                        <dl class="child">
                            <dt>성별을 선택해주세요.</dt>
                            <dd class="flex-between">
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr2" value="M" id="male-2" @keyup="checkVal">
                                    <label for="male-2">남</label>
                                </span>
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr2" value="F" id="female-2" @keyup="checkVal">
                                    <label for="female-2">여</label>
                                </span>
                            </dd>
                            <dt>생년월일을 입력해주세요. <span>(예: 20150101)</span></dt>
                            <dd>
                                <input type="tel" ref="chlnbdt2" id="chlnbdt2" :value="custInfo.chlnbdt2" v-on:input="checkText($event)" placeholder="8자리를 입력해주세요. (예 : 20150101)" @keyup="checkVal">
                                <input type="text" ref="age2" disabled>
                            </dd>
                            <dt>이름</dt>
                            <dd><input type="text" ref="chlnnam2" id="chlnnam2" :value="custInfo.chlnnam2" v-on:input="checkText($event)" placeholder="자녀 이름을 입력해주세요."></dd>
                        </dl>
                        <button type="button" class="child-del" @click="delChild('2')">자녀 삭제</button>
                    </div>
                    <div class="sub" v-if="child3">
                        <h6>자녀3</h6>
                        <dl class="child">
                            <dt>성별을 선택해주세요.</dt>
                            <dd class="flex-between">
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr3" value="M" id="male-3" @keyup="checkVal">
                                    <label for="male-3">남</label>
                                </span>
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr3" value="F" id="female-3" @keyup="checkVal">
                                    <label for="female-3">여</label>
                                </span>
                            </dd>
                            <dt>생년월일을 입력해주세요. <span>(예: 20150101)</span></dt>
                            <dd>
                                <input type="tel" ref="chlnbdt3" id="chlnbdt3" :value="custInfo.chlnbdt3" v-on:input="checkText($event)" placeholder="8자리를 입력해주세요. (예 : 20150101)" @keyup="checkVal">
                                <input type="text" ref="age3" disabled>
                            </dd>
                            <dt>이름</dt>
                            <dd><input type="text" ref="chlnnam3" id="chlnnam3" :value="custInfo.chlnnam3" v-on:input="checkText($event)" placeholder="자녀 이름을 입력해주세요."></dd>
                        </dl>
                        <button type="button" class="child-del" @click="delChild('3')">자녀 삭제</button>
                    </div>
                    <div class="sub" v-if="child4">
                        <h6>자녀4</h6>
                        <dl class="child">
                            <dt>성별을 선택해주세요.</dt>
                            <dd class="flex-between">
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr4" value="M" id="male-4" @keyup="checkVal">
                                    <label for="male-4">남</label>
                                </span>
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr4" value="F" id="female-4" @keyup="checkVal">
                                    <label for="female-4">여</label>
                                </span>
                            </dd>
                            <dt>생년월일을 입력해주세요. <span>(예: 20150101)</span></dt>
                            <dd>
                                <input type="tel" ref="chlnbdt4" id="chlnbdt4" :value="custInfo.chlnbdt4" v-on:input="checkText($event)" placeholder="8자리를 입력해주세요. (예 : 20150101)" @keyup="checkVal">
                                <input type="text" ref="age4" disabled>
                            </dd>
                            <dt>이름</dt>
                            <dd><input type="text" ref="chlnnam4" id="chlnnam4" :value="custInfo.chlnnam4" v-on:input="checkText($event)" placeholder="자녀 이름을 입력해주세요."></dd>
                        </dl>
                        <button type="button" class="child-del" @click="delChild('4')">자녀 삭제</button>
                    </div>
                    <div class="sub" v-if="child5">
                        <h6>자녀5</h6>
                        <dl class="child">
                            <dt>성별을 선택해주세요.</dt>
                            <dd class="flex-between">
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr5" value="M" id="male-5" @keyup="checkVal">
                                    <label for="male-5">남</label>
                                </span>
                                <span class="radioBtn">
                                    <input type="radio" v-model.trim="custInfo.chlngndr5" value="F" id="female-5" @keyup="checkVal">
                                    <label for="female-5">여</label>
                                </span>
                            </dd>
                            <dt>생년월일을 입력해주세요. <span>(예: 20150101)</span></dt>
                            <dd>
                                <input type="tel" ref="chlnbdt5" id="chlnbdt5" :value="custInfo.chlnbdt5" v-on:input="checkText($event)" placeholder="8자리를 입력해주세요. (예 : 20150101)" @keyup="checkVal">
                                <input type="text" ref="age5" disabled>
                            </dd>
                            <dt>이름</dt>
                            <dd><input type="text" ref="chlnnam5" id="chlnnam5" :value="custInfo.chlnnam5" v-on:input="checkText($event)" placeholder="자녀 이름을 입력해주세요."></dd>
                        </dl>
                        <button type="button" class="child-del" @click="delChild('5')">자녀 삭제</button>
                    </div>
                    <button type="button" class="child-add" @click="addChild()" v-if="maxNum < 5">자녀추가하기</button>                    
                </div>
            </div>
            <div class="wrap" id="pos03" ref="pos03" :style="{order:cardSort['CRS04']}">
                <button type="button">메모</button>
                <div class="memo-input">
                    <textarea ref="memo" id="memo" :value="memo" v-on:input="checkText($event)" placeholder="메모를 입력해주세요."></textarea>
                    <span><em>{{memoLength}}</em>/500</span>
                </div>
            </div>
            <div class="wrap" id="pos04" ref="pos04" :style="{order:cardSort['CRS05']}">
                <button type="button">부모정보</button>
                <div>
                    <dl>
                        <dt>성별을 선택해주세요.</dt>
                        <dd class="flex-between">
                            <span class="radioBtn">
                                <input type="radio" v-model.trim="custInfo.custgndr" value="M" id="male" @keyup="checkVal">
                                <label for="male">남</label>
                            </span>
                            <span class="radioBtn">
                                <input type="radio" v-model.trim="custInfo.custgndr" value="F" id="female" @keyup="checkVal">
                                <label for="female">여</label>
                            </span>
                        </dd>
                        <dt>생년월일을 입력해주세요. <span>(예: 19800521)</span></dt>
                        <dd>
                            <input type="tel" ref="custbrdt" id="custbrdt" :value="custInfo.custbrdt" v-on:input="checkText($event)" placeholder="8자리를 입력해주세요. (예 : 19800521)" @keyup="checkVal">
                            <input type="text" ref="age" disabled>
                        </dd>
                        <dt>주소를 입력해주세요<div class=""></div></dt>
                        <dd>
                            <input type="text" v-model.trim="custInfo.custadr1" ref="custadr1" id="custadr1" placeholder="주소를 선택해주세요." @click="popPost" @keyup="popPost" readonly>
                            <input type="text" ref="custadr2" id="custadr2" :value="custInfo.custadr2" v-on:input="checkText($event)" placeholder="상세주소를 입력해주세요. (아파트 동/호수 등)">
                        </dd>
                    </dl>                    
                </div>
            </div>
            <div class="wrap" id="pos05" ref="pos05" :style="{order:cardSort['CRS06']}">
                <button type="button">관심정보</button>
                <div>
                    <dl>
                        <dt>교육 관심도</dt>
                        <dd class="flex-between">
                            <span class="radioBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CED' )" :key="index">
                                <input type="radio" :name="code.prenCd" v-model="valueOfCED" :value="code.cdVl1" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dt>교육 관심분야</dt>
                        <dd class="grid">
                            <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CEC' )" :key="index">
                                <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dt>교육 정보 출처</dt>
                        <dd class="grid">
                            <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CIP' )" :key="index">
                                <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dt>학습 활동</dt>
                        <dd class="grid">
                            <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CLA' )" :key="index">
                                <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dt>관심 전집</dt>
                        <dd class="grid">
                            <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CMC' )" :key="index">
                                <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dt>교육비(월)</dt>
                        <dd class="grid">
                            <span class="radioBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CMM' )" :key="index">
                                <input type="radio" :name="code.prenCd" v-model="valueOfCMM" :value="code.cdVl1" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dt>관심도구</dt>
                        <dd class="flex-between">
                            <span class="checkBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CDS' )" :key="index">
                                <input type="checkbox" v-model="code.custvalu" true-value="Y" false-value="N" :id="code.cdVl1">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                    </dl>
                </div>
            </div>
            <div class="wrap" id="pos06" ref="pos06" :style="{order:cardSort['CRS01']}">
                <button type="button">무진활동</button>
                <div>
                    <dl>
                        <dt>활동을 선택해주세요.</dt>
                        <dd class="grid">
                            <span class="radioBtn" v-for="(code, index) in custInterestInfoList.filter((code) => code.prenCd == 'CRD' )" :key="index">
                                <input type="radio" :name="code.prenCd" v-model="custInfo.prensrno" :value="code.cdVl1" :id="code.cdVl1" @change="checkCRD(code.cdVl1)">
                                <label :for="code.cdVl1">{{code.cdNm}}</label>
                            </span>
                        </dd>
                        <dd><input type="text" v-model="custInfo.custnote" ref="custnote" id="custnote" placeholder="기타 선택 시 장소 입력해주세요.(예 : oo공원 앞)" v-show="custInfo.prensrno == 78"></dd>
                    </dl>
                </div>
            </div>
        </div>
    </section>
    <div class="btnWrap">
        <button type="button" class="white" @click="cancel()">취소</button>
        <button type="button" class="red" @click="regMyCstmr()">등록</button>
    </div>

    <template v-if="terms">
        <div class="dim">
            <div class="botWrap">
                <h6>약관동의</h6>
                <div class="register-terms">
                    <span class="checkbox circle">
                        <input type="checkbox" v-model="isCheckAll" name="cert-all" id="cert-all" @change="checkAll">
                        <label for="cert-all">전체동의</label>
                    </span>
                    
                    <span class="checkbox">
                        <input type="checkbox" v-model="custInfo.infoagre" true-value="Y" false-value="N" id="cert-1" @change="checkTerm1">
                        <label for="cert-1" >[필수] 모바일 개인정보 수집 및 이용동의</label>
                    </span>
                    <button type="button" class="view" @click="popAgreeInfo">보기</button>
                    
                    <span class="checkbox">
                        <input type="checkbox" v-model="custInfo.mrknagre" true-value="Y" false-value="N" id="cert-2" @change="checkTerm2">
                        <label for="cert-2">[선택] 마케팅 목적 활용 동의</label>
                    </span>
                    <button type="button" class="view" @click="popAgreeInfo">보기</button>

                    <button type="button" class="confirm" @click="regNext">확인</button>
                </div>
                <button type="button" class="close" @click="closeTerm">닫기</button>
            </div>
        </div>
    </template>

    <template v-if="auth">
        <div class="dim">
            <div class="botWrap">
                <h6>인증하기</h6>
                <div class="register-cert">
                    <strong>인증번호를 입력해주세요.</strong>
                    <div>
                        <input type="tel" v-model="athnNo" ref="athnNo" @keyup.enter="authCmplt">
                        <em>{{resTimeData}}</em>
                        <button type="button" class="request" @click="reSendReq">재요청</button>
                    </div>

                    <button type="button" class="cplt" @click="authCmplt" :disabled="timeCounter <= 0">인증완료</button>
                </div>
                <button type="button" class="close" @click="closeAuth">닫기</button>
            </div>
        </div>
    </template>
</div>
</template>

<script>

export default {
  data(){
      return{
        custInfo: {
            custname: "", // 고객명
            custsrno: 0, // 잠재고객일련번호
            custhno: "010", // 전체 휴대전화
            custhno1: "", // 휴대전화지역
            custhno2: "", // 휴대전화국번
            custhno3: "", // 휴대전화번호
            custgndr: "", // 고객성별 m 남 f 여
            custbrdt: "", // 부모생년월일
            custzpcd: "", // 우편번호
            custadr1: "", // 주소1
            custadr2: "", // 주소2
            custnote: "", // 개별작성메모, 무진활동 기타일 때 장소
            chlnnam1: "", // 자녀명1
            chlnbdt1: "", // 자녀생년월일1
            chlngndr1: "", // 자녀성별1
            chlnschl1: "", // 자녀학교명1
            chlnnam2: "", // 자녀명2
            chlnbdt2: "", // 자녀생년월일2
            chlngndr2: "", // 자녀성별2	
            chlnschl2: "", // 자녀학교명2
            chlnnam3: "", // 자녀명3
            chlnbdt3: "", // 자녀생년월일3
            chlngndr3: "", // 자녀성별3
            chlnschl3: "", // 자녀학교명3
            chlnnam4: "", // 자녀명4
            chlnbdt4: "", // 자녀생년월일4
            chlngndr4: "", // 자녀성별4
            chlnschl4: "", // 자녀학교명4
            chlnnam5: "", // 자녀명5
            chlnbdt5: "", // 자녀생년월일5
            chlngndr5: "", // 자녀성별5
            chlnschl5: "", // 자녀학교명5
            prensrno: "", // 무진형태일련번호 2 마트무진 4 유아박람회 100 에듀 체험센터 1 무빙북카페 72 키즈라운지 78 기타 
            mrknagre: "N",
            infoagre: "N",
        },
        validAuthYn: false,
        custInterestInfoList: [], // 관심정보 및 무진활동
        tempCustInterestInfoList: [], // 관심정보 및 무진활동 서버 전달용.
        valueOfCED: "",
        valueOfCMM: "",
        memo: "", // 메모
        memoLength: 0,
        slideMenu: {
          slidesPerView: 'auto',
        },
        terms: false,
        auth: false,
        child2: false,
        child3: false,
        child4: false,
        child5: false,
        maxNum: 1,
        encSqno: "",
        athnNo: "",
        isCheckAll: false,
        regDulCount: -1,
        move: false,
        tabActive: 1,
        polling: null,
        timeCounter: 300, //5분 
        resTimeData: '05:00',
        cardSort: {'CRS01':6,'CRS02':1,'CRS03':2,'CRS04':3,'CRS05':4,'CRS06':5},    //카드 순서
      };
    },
	watch: { // 팝업창에서 선택된 값 받는 부분.
		'$store.state.ui.child'(child) {
			if(child.name == 'juso-selected'){  // 주소검색 팝업에서 받은 값.
                this.custInfo.custzpcd = this.$store.state.ui.child.data.zipNo;
                this.custInfo.custadr1 = this.$store.state.ui.child.data.roadAddr;
                this.$refs.custadr2.focus();
			} else if(child.name == 'native-location'){ 
                // 배명훈, 2021.11.10, 주소정보 조회 IF
                var value = this.$store.state.ui.child.data;
                console.log(value);
                // alert(value.rt);
                // alert(value.lati + "/" + value.long);
			}
        }
    },
    created () {
        window.addEventListener('scroll', this.focusScroll);
        // 배명훈, 2021.11.10, 주소정보 조회 IF
        // this.$utils.nativeIf.outbound.getLocation();
    },
    destroyed () {
        window.removeEventListener('scroll', this.focusScroll);
    },
    methods: {
        focusScroll () {
            this.isUserScrolling = (window.scrollY > 0);
            this.pos01Top = this.$refs.pos01.offsetTop;
            this.pos01 = this.$refs.pos01.offsetTop + this.$refs.pos01.clientHeight;
            this.pos02Top = this.$refs.pos02.offsetTop;
            this.pos02 = this.$refs.pos02.offsetTop + this.$refs.pos02.clientHeight;
            this.pos03Top = this.$refs.pos03.offsetTop;
            this.pos03 = this.$refs.pos03.offsetTop + this.$refs.pos03.clientHeight;
            this.pos04Top = this.$refs.pos04.offsetTop;
            this.pos04 = this.$refs.pos04.offsetTop + this.$refs.pos04.clientHeight;
            this.pos05Top = this.$refs.pos05.offsetTop;
            this.pos05 = this.$refs.pos05.offsetTop + this.$refs.pos05.clientHeight;
            this.pos06Top = this.$refs.pos06.offsetTop;
            this.pos06 = this.$refs.pos06.offsetTop + this.$refs.pos06.clientHeight;

            if(this.isUserScrolling){
                this.move = true
                var scrollSum = window.scrollY + 120;
                if(scrollSum >= this.pos01Top && scrollSum <= this.pos01){
                        this.tabActive = this.cardSort['CRS02'];
                }else if(scrollSum >= this.pos02Top && scrollSum <= this.pos02){
                        this.tabActive = this.cardSort['CRS03'];
                }else if(scrollSum >= this.pos03Top && scrollSum <= this.pos03){
                        this.tabActive = this.cardSort['CRS04'];
                }else if(scrollSum >= this.pos04Top && scrollSum <= this.pos04){
                        this.tabActive = this.cardSort['CRS05'];
                }else if(scrollSum >= this.pos05Top && scrollSum <= this.pos05){
                        this.tabActive = this.cardSort['CRS06'];
                }else if(scrollSum >= this.pos06Top && scrollSum <= this.pos06){
                        this.tabActive = this.cardSort['CRS01'];
                }
            }else{
                this.move = false
            }

            if( window.scrollY > this.$refs.body.scrollHeight/2){
                this.$refs.tabObj.style.transform = 'translate3d(-100px, 0px, 0px)'
                this.$refs.tabObj.style.transform = 'transition-duration: 300ms'
            }
        },
        focus(val){
            var d = document.getElementById('pos0'+val);
            var topPos = d.offsetTop - 110;
            window.scrollTo({top:topPos});
            this.tabActive = val
        },
        params() { // 등록/수정 데이터 리턴. 날짜는 '-' 제거.
            return {
                custname: this.custInfo.custname,
                custhno1: this.custInfo.custhno1,
                custhno2: this.custInfo.custhno2,
                custhno3: this.custInfo.custhno3,
                custgndr: this.custInfo.custgndr,
                custbrdt: this.custInfo.custbrdt,
                custzpcd: this.custInfo.custzpcd,
                custadr1: this.custInfo.custadr1,
                custadr2: this.custInfo.custadr2,
                chlnnam1: this.custInfo.chlnnam1,
                chlnbdt1: this.custInfo.chlnbdt1,
                chlngndr1: this.custInfo.chlngndr1,
                chlnnam2: this.custInfo.chlnnam2,
                chlnbdt2: this.custInfo.chlnbdt2,
                chlngndr2: this.custInfo.chlngndr2,
                chlnnam3: this.custInfo.chlnnam3,
                chlnbdt3: this.custInfo.chlnbdt3,
                chlngndr3: this.custInfo.chlngndr3,
                chlnnam4: this.custInfo.chlnnam4,
                chlnbdt4: this.custInfo.chlnbdt4,
                chlngndr4: this.custInfo.chlngndr4,
                chlnnam5: this.custInfo.chlnnam5,
                chlnbdt5: this.custInfo.chlnbdt5,
                chlngndr5: this.custInfo.chlngndr5,
                prensrno: this.custInfo.prensrno,                
                custnote: this.custInfo.custnote,
                infoagre: this.custInfo.infoagre,  
                mrknagre: this.custInfo.mrknagre,  
                interestListJsonString: JSON.stringify(this.tempCustInterestInfoList),
                memo: this.memo

            };
        },
        termsView(){ // 약관동의 창 보이기
            if(!this.terms){
                var validate1 = this.validate1();
                if(!validate1) {
                    return;
                }
            }
            this.terms = !this.terms;
        },
        checkAll(){ // 전체동의 체크시
            if(this.isCheckAll){
                this.custInfo.infoagre = "Y";
                this.custInfo.mrknagre = "Y";
            }else{
                this.custInfo.infoagre = "N";
                this.custInfo.mrknagre = "N";
            }
        },
        checkTerm1(){ // 모바일 개인정보 수집 및 이용동의
            if(this.custInfo.infoagre == "Y" && this.custInfo.mrknagre == "Y"){
                this.isCheckAll = true;
            }else{                
                this.isCheckAll = false;
            }
        },
        checkTerm2(){ // 마케팅 목적 활용 동의
            if(this.custInfo.infoagre == "Y" && this.custInfo.mrknagre == "Y"){
                this.isCheckAll = true;
            }else{                
                this.isCheckAll = false;
            }
        },
        closeTerm(){ // 약관 관련 초기화
            this.isCheckAll = false;
            this.custInfo.infoagre = "N";
            this.custInfo.mrknagre = "N";
            this.terms = false;
        },
        regNext(){ // 약관동의 확인버튼 클릭시
            if (this.custInfo.infoagre == "N") {
                alert("필수항목을 동의해주세요.");
                return false;
            }
            this.saveCustAthn();
            this.termsView();
            this.authView();
        },
        authView(){ // 인증하기 창 열기
            this.auth = !this.auth;
        },
        closeAuth(){ // 인증하기 창 닫기
            this.closeTerm(); // 약관 관련 초기화

            this.athnNo = "";
            this.auth = false;
            this.timeStop();
        },
        authCmplt(){ //인증완료 버튼 클릭시
            this.validAuthNo()
        },
        reSendReq(){ // 인증문자 재발송   
            var that = this;     
            var params = {encSqno:this.encSqno, name:this.custInfo.custname, phoneNum:this.custInfo.custhno};
            console.log("MyCstmrReg.vue reSendReq params ", params);

            this.$api.myCstmr.issueAuthNo(params)
                .then(function(res) {
                    console.log("MyCstmrReg.vue reSendReq res ", res);
                    that.timerRestart();
                })
                .catch(function(error) {
                    alert(error.rtMsg); 
                });
        },
        saveCustAthn(){ // ep 고객등록시 인증문자 발송
            var that = this;
            var validate1 = this.validate1();
            if(!validate1) {
                return;
            }
            var params = {custNm:this.custInfo.custname, kwctlNo:this.custInfo.custhno};

            this.$api.myCstmr.saveCustAthn(params)
                .then(function(res) {
                    console.log("MyCstmrReg.vue saveCustAthn res ", res);
                    that.encSqno = res.encSqno;
                    // timer 초기화 및 시작
                    that.timerRestart();
                })
                .catch(function(error) {
                    alert(error.rtMsg); 
                });
        },
        timerRestart(){ //timer 재시작
            this.timeCounter = 300; // 초기화
            this.timeStop();
            this.timerStart();
        },
        timerStart(){ //timer 시작
            // 1초에 한번씩 start 호출 
            this.polling = setInterval( () =>{ 
                this.timeCounter = this.timeCounter -1;
                this.resTimeData = this.preTime();
                if (this.timeCounter <= 0) this.timeStop() 
                },1000) 
        },
        preTime() { // timeCounter를 분:초로 리턴
            var time = this.timeCounter / 60 
            var minutes = parseInt(time) 
            var secondes = Math.round((time - minutes) * 60) 
            return this.pad(minutes, 2) + ":" + this.pad(secondes, 2) 
        },
        pad(n, width) { // 숫자 n을 일정한 자리수(width)로 채워서 리턴.
            n = n + ''; 
            return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n 
        },
        timeStop() { 
            clearInterval(this.polling);
        },
        validAuthNo(){ // 인증하기
            var that = this;
            var params = {encSqno:this.encSqno, athnNo:this.athnNo};

            this.$api.myCstmr.validAuthNo(params)
                .then(function() {
                    that.validAuthYn = true;
                    that.authView();
                    that.timeStop();
                })
                .catch(function(error) {
                    that.athnNo = "";
                    alert(error.rtMsg);
                });
        },
        sendAuthMMS(){ // 고객등록 바로가기 인증문자 발송
            var that = this;
            var validate1 = this.validate1();
            if(!validate1) {
                return;
            }

            var params = {custNm:this.custInfo.custname, kwctlNo:this.custInfo.custhno};
            //console.log("MyCstmrReg.vue sendAuthMMS params ", params);
            
            this.$api.myCstmr.sendAuthMMS(params)
                .then(function() {
                    alert(" 문자 발송되었습니다. \n 해당 창은 닫히며, 나머지 정보는 \n 고객상세에서 입력진행해 주세요.");                    
                    that.$router.push('/main');
                })
                .catch(function(error) {
                    alert(error.rtMsg); 
                    alert("문자 발송이 안되었습니다. \n 다시 시도해주세요.");
                });

        },
        popAgreeInfo(){ // 약관동의 창 띄우기
            this.$utils.nativeIf.outbound.newPage('/myCstmr/myCstmrView/popAgreeInfo');
        },
        popPost(){ // 주소검색 창 띄우기
            this.$utils.nativeIf.outbound.newPage('/commonPopup/postSearch/');
        },
        regDulCheck: function(e){ // 같은 지국내 동일한 번호가 있는지 체크 
            console.log('blur', e.target.placeholder)
            
            this.regDulCount = -1; // 체크값 초기화.
            this.validAuthYn = false; // 인증 초기화.
            
            var custhno = this.custInfo.custhno;
            
            if (this.$utils.stringUtil.isNull(this.custInfo.custhno)) {
                alert("휴대폰 번호가 입력되지 않았습니다. 인증을 완료해주세요.");
                //this.$refs.custhno.focus(); // 무한루프 빠지지 않게 휴대폰번호는 뺀다.
                return false;
            }
            if(custhno.length == 10){
                this.custInfo.custhno1 = this.custInfo.custhno.substr(0,3);
                this.custInfo.custhno2 = this.custInfo.custhno.substr(3,3);
                this.custInfo.custhno3 = this.custInfo.custhno.substr(6,4);
            }else if(custhno.length == 11){
                this.custInfo.custhno1 = this.custInfo.custhno.substr(0,3);
                this.custInfo.custhno2 = this.custInfo.custhno.substr(3,4);
                this.custInfo.custhno3 = this.custInfo.custhno.substr(7,4);
            }else{
                alert("휴대폰번호를 정확히 입력해주세요.");
                //this.$refs.custhno.focus(); // 포커스를 주면 바로 blur 처리되서 무한루프돈다.
                return;
            }

            var that = this;
            var params = {tel1:this.custInfo.custhno1, tel2:this.custInfo.custhno2, tel3:this.custInfo.custhno3};
            
            this.$api.myCstmr.getCountForDulCheck(params)
                .then(function(res) {
                    console.log("MyCstmrReg.vue getCountForDulCheck res:",res);
                    that.regDulCount = res;                    
                })
                .catch(function(error) {
                    alert(error.rtMsg); 
                });
        },
        checkVal: function(e){ // 정합성 체크 및 포커스 이동
            // console.log("MyCstmrReg.vue checkVal e.target.ref:",e.target.ref);
            // console.log("MyCstmrReg.vue checkVal e.target.id:",e.target.id);
            // console.log("MyCstmrReg.vue checkVal ,e.target.value.length:",e.target.value.length);
            if(e.target.id == 'custhno' ){
                this.custInfo.custhno = e.target.value.replace(/[^0-9]/gi,'');
                if(e.target.value.length == 11){
                    this.$refs.custname.focus();
                    //this.regDulCheck();
                }
            }else if(e.target.id == 'male' || e.target.id == 'female' ){
                    this.$refs.custbrdt.focus();
            }else if(e.target.id == 'custbrdt' ){
                if(e.target.value.length == 8){
                    this.$refs.age.value = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.custadr1.focus();
                }
            }else if(e.target.id == 'male-1' || e.target.id == 'female-1' ){
                    this.$refs.chlnbdt1.focus();
            }else if(e.target.id == 'chlnbdt1' ){
                if(e.target.value.length == 8){
                    this.$refs.age1.value = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.chlnnam1.focus();
                }
            }else if(e.target.id == 'male-2' || e.target.id == 'female-2' ){
                    this.$refs.chlnbdt2.focus();
            }else if(e.target.id == 'chlnbdt2' ){
                if(e.target.value.length == 8){
                    this.$refs.age2.value = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.chlnnam2.focus();
                }
            }else if(e.target.id == 'male-3' || e.target.id == 'female-3' ){
                    this.$refs.chlnbdt3.focus();
            }else if(e.target.id == 'chlnbdt3' ){
                if(e.target.value.length == 8){
                    this.$refs.age3.value = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.chlnnam3.focus();
                }
            }else if(e.target.id == 'male-4' || e.target.id == 'female-4' ){
                    this.$refs.chlnbdt4.focus();
            }else if(e.target.id == 'chlnbdt4' ){
                if(e.target.value.length == 8){
                    this.$refs.age4.value = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.chlnnam4.focus();
                }
            }else if(e.target.id == 'male-5' || e.target.id == 'female-5' ){
                    this.$refs.chlnbdt5.focus();
            }else if(e.target.id == 'chlnbdt5' ){
                if(e.target.value.length == 8){
                    this.$refs.age5.value = this.$utils.calendar.getAge2(e.target.value);
                    this.$refs.chlnnam5.focus();
                }
            }
        },
        delChild: function(num){ // 자녀정보 삭제
            //console.log("MyCstmrReg.vue delChild num:", num);
            if( num == '2' ){
                this.custInfo.chlnnam2 = "";
                this.custInfo.chlnbdt2 = "";
                this.custInfo.chlngndr2 = "";
                this.child2 = false;
            }else if( num == '3' ){
                this.custInfo.chlnnam3 = "";
                this.custInfo.chlnbdt3 = "";
                this.custInfo.chlngndr3 = "";
                this.child3 = false;
            }else if( num == '4' ){
                this.custInfo.chlnnam4 = "";
                this.custInfo.chlnbdt4 = "";
                this.custInfo.chlngndr4 = "";
                this.child4 = false;
            }else if( num == '5' ){
                this.custInfo.chlnnam5 = "";
                this.custInfo.chlnbdt5 = "";
                this.custInfo.chlngndr5 = "";
                this.child5 = false;
            }
            this.maxNum--;
            //console.log("MyCstmrReg.vue delChild this.custInfo:", this.custInfo);
        },
        addChild: function(){ // 자녀정보 추가
            if( !this.child2 ){
                this.child2 = true;
            }else if( !this.child3 ){
                this.child3 = true;
            }else if( !this.child4 ){
                this.child4 = true;
            }else if( !this.child5 ){
                this.child5 = true;
            }
            this.maxNum++;
        },
        checkCRD: function(cdVl1) { // 무진활동 선택시
            // console.log("cdVl1 ",cdVl1);
            // console.log("this.custInfo.prensrno ",this.custInfo.prensrno);
            // console.log("this.custInfo.custnote ",this.custInfo.custnote);
            if("78" != cdVl1){ // 무진활동 기타가 아닐 때
                this.custInfo.custnote = '';
            }else{
                this.$refs.custnote.focus();
            }
        },
        validate1() { // 유효성 체크        
            // var    custhno1 = this.custInfo.custhno.substr(0,3);
            // var    custhno2 = this.custInfo.custhno.substr(3,4);
            // var    custhno3 = this.custInfo.custhno.substr(7,4);
            // console.log("custhno1", custhno1);
            // console.log("custhno2", custhno2);
            // console.log("custhno3", custhno3);
            if (this.$utils.stringUtil.isNull(this.custInfo.custhno)) {
                alert("휴대폰 번호가 입력되지 않았습니다.");
                //this.$refs.custhno.focus(); // 무한루프 빠지지 않게 휴대폰번호는 뺀다.
                return false;
            }
            if (this.custInfo.custhno.length < 10) {
                alert("휴대폰번호를 정확히 입력해주세요.");
                //this.$refs.custhno.focus(); // 무한루프 빠지지 않게 휴대폰번호는 뺀다.
                return false;
            }
            if(this.regDulCount != 0) {
                alert("이미 등록된 번호입니다. 등록가능한 번호를 입력해주세요.");      
                this.custInfo.custhno = "010";
                this.regDulCount = -1;
                //this.$refs.custname.focus();
                //this.$refs.custhno.focus(); // 무한루프 빠지지 않게 휴대폰번호는 뺀다.            
                return false;
            }
            if (this.$utils.stringUtil.isNull(this.custInfo.custname)) {
                alert("이름이 입력되지 않았습니다.");
                this.$refs.custname.focus();
                return false;
            }
            return true;
        },
        validate2() { // 유효성 체크 
            if (!this.validAuthYn) {
                alert("인증 후 등록해주세요.");
                return false;
            }
            if (this.custInfo.prensrno == '78' && this.$utils.stringUtil.isNull(this.custInfo.custnote)) {
                alert("무진활동이 기타일 때 장소를 입력해주세요.");
                this.$refs.custnote.focus();
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.custInfo.custbrdt) && !this.$utils.calendar.isBirthday(this.custInfo.custbrdt)) {
                alert("부모나이를 정확하게 입력해주세요.");
                this.$refs.custbrdt.focus();
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.custInfo.chlnbdt1) && !this.$utils.calendar.isBirthday(this.custInfo.chlnbdt1)) {
                alert("자녀나이를 정확하게 입력해주세요.");
                this.$refs.chlnbdt1.focus();
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.custInfo.chlnbdt2) && !this.$utils.calendar.isBirthday(this.custInfo.chlnbdt2)) {
                alert("자녀나이를 정확하게 입력해주세요.");
                this.$refs.chlnbdt2.focus();
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.custInfo.chlnbdt3) && !this.$utils.calendar.isBirthday(this.custInfo.chlnbdt3)) {
                alert("자녀나이를 정확하게 입력해주세요.");
                this.$refs.chlnbdt3.focus();
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.custInfo.chlnbdt4) && !this.$utils.calendar.isBirthday(this.custInfo.chlnbdt4)) {
                alert("자녀나이를 정확하게 입력해주세요.");
                this.$refs.chlnbdt4.focus();
                return false;
            }
            if (!this.$utils.stringUtil.isNull(this.custInfo.chlnbdt5) && !this.$utils.calendar.isBirthday(this.custInfo.chlnbdt5)) {
                alert("자녀나이를 정확하게 입력해주세요.");
                this.$refs.chlnbdt5.focus();
                return false;
            }
            return true;
        },
        cancel(){ // 취소 버튼 클릭시
            if(confirm("등록 취소하시겠습니까?")){
                // this.$router.back();
                this.$router.push({ name: 'main' }).catch(function() {});
            }
        },
        regMyCstmr(){ // 고객 등록
            var that = this;
            
            if(!this.validate1()) {
                return;
            }
            if(!this.validate2()) {
                return;
            }
            if(!confirm("입력한 정보로 등록하시겠습니까?")){
                return;
            }

            // 선택된 교육 관심도는 Y, 나머지는 N이 셋팅
            var interestCED = this.custInterestInfoList.filter(interest => interest.prenCd === "CED");
            for(var i=0; i < interestCED.length; i++){
                console.log("interestCED[i]", interestCED[i]);
                if(interestCED[i].cdVl1 == this.valueOfCED){
                    interestCED[i].custvalu = "Y";
                }else{
                    interestCED[i].custvalu = "N";
                }
            }
            
            // 선택된 교육비(월)은 Y, 나머지는 N이 셋팅
            var interestCMM = this.custInterestInfoList.filter(interest => interest.prenCd === "CMM");
            for(var j=0; j < interestCMM.length; j++){
                console.log("interestCMM[j]", interestCMM[j]);
                if(interestCMM[j].cdVl1 == this.valueOfCMM){
                    interestCMM[j].custvalu = "Y";
                }else{
                    interestCMM[j].custvalu = "N";
                }
            }
            
            this.tempCustInterestInfoList = this.custInterestInfoList.slice();

            for(var k=this.tempCustInterestInfoList.length - 1; k > -1; k--){
                if(this.tempCustInterestInfoList[k].custvalu == "N"){
                    this.tempCustInterestInfoList.splice(k,1);
                }
            }
            
            var params = this.params();
            
            //console.log("MyCstmrReg.vue regMyCstmr params", params);

            this.$api.myCstmr.saveMyCstmr(params)
                .then(function(res) {                    
                    console.log("MyCstmrReg.vue regMyCstmr res.custsrno", res.custsrno);
                    that.custInfo.custsrno = res.custsrno;

                    //  무진활동 store에 저장.
                    var todayDate = new Date();
                    var todayYYYYMMDD = todayDate.getFullYear() + that.pad(todayDate.getMonth() + 1,2) + that.pad(todayDate.getDate(),2);
                    
                    var prensrnoinfo = {
                        name: 'my-cstmr-reg-default',
                        data: {saveDate:todayYYYYMMDD,prensrno:that.custInfo.prensrno,custnote:that.custInfo.custnote}
                    };

                    //console.log("MyCstmrReg.vue saveMyCstmr prensrnoinfo", prensrnoinfo);
                    that.$store.commit("SET_UI_PRENSRNOINFO", prensrnoinfo);
                    
                    that.goRegResultPage();
                })
                .catch(function(error) {
                    alert(error.rtMsg);

                    // 등록시 에러나면 전화번호 체크, 인증관련 값 초기화.
                    that.isCheckAll = false;
                    that.custInfo.infoagre = "N";
                    that.custInfo.mrknagre = "N";
                    that.terms = false;

                    that.validAuthYn = false; // 인증 초기화.
                    that.athnNo = "";
                    
                    //that.custInfo.custhno = "010"; // 전화번호 초기화
                    //that.regDulCount = -1; // 전화번호 중복체크값 초기화.    
                });

        },
        goRegResultPage: function(){ // 가망고객 등록 후 결과페이지로 이동
            var searchCustNm = this.custInfo.custname;
            var custsrno = this.custInfo.custsrno;
            
            //console.log("MyCstmrReg.vue regMyCstmr searchCustNm", searchCustNm);

            var parent = {
                name: 'my-cstmr-reg-result-param',
                data: 
                {
                    searchCustNm:searchCustNm,
                    custsrno: custsrno
                }
            };
            //console.log("MyCstmrReg.vue regMyCstmr parent", parent);
            this.$store.commit("SET_UI_PARENT", parent);
            
            this.$router.push('/myCstmr/myCstmrReg/myCstmrRegResult');
        },
        checkText: function(e){  // 입력값 길이제한 
            if(e.target.id == 'custhno' ){
                if(e.target.value.length > 11){
                    e.target.value = e.target.value.substr(0,11);
                }else{
                    this.custInfo.custhno = e.target.value;
                }
            }
            if(e.target.id == 'custname' ){
                if(e.target.value.length > 10){
                    e.target.value = e.target.value.substr(0,10);
                }else{
                    this.custInfo.custname = e.target.value;
                }
            }
            if(e.target.id == 'chlnbdt1' ){
                if(e.target.value.length > 8){
                    e.target.value = e.target.value.substr(0,8);
                }else{
                    this.custInfo.chlnbdt1 = e.target.value;
                }
            }
            if(e.target.id == 'chlnnam1' ){
                if(e.target.value.length > 10){
                    e.target.value = e.target.value.substr(0,10);
                }else{
                    this.custInfo.chlnnam1 = e.target.value;
                }
            }
            if(e.target.id == 'chlnbdt2' ){
                if(e.target.value.length > 8){
                    e.target.value = e.target.value.substr(0,8);
                }else{
                    this.custInfo.chlnbdt2 = e.target.value;
                }
            }
            if(e.target.id == 'chlnnam2' ){
                if(e.target.value.length > 10){
                    e.target.value = e.target.value.substr(0,10);
                }else{
                    this.custInfo.chlnnam2 = e.target.value;
                }
            }
            if(e.target.id == 'chlnbdt3' ){
                if(e.target.value.length > 8){
                    e.target.value = e.target.value.substr(0,8);
                }else{
                    this.custInfo.chlnbdt3 = e.target.value;
                }
            }
            if(e.target.id == 'chlnnam3' ){
                if(e.target.value.length > 10){
                    e.target.value = e.target.value.substr(0,10);
                }else{
                    this.custInfo.chlnnam3 = e.target.value;
                }
            }
            if(e.target.id == 'chlnbdt4' ){
                if(e.target.value.length > 8){
                    e.target.value = e.target.value.substr(0,8);
                }else{
                    this.custInfo.chlnbdt4 = e.target.value;
                }
            }
            if(e.target.id == 'chlnnam4' ){
                if(e.target.value.length > 10){
                    e.target.value = e.target.value.substr(0,10);
                }else{
                    this.custInfo.chlnnam4 = e.target.value;
                }
            }
            if(e.target.id == 'chlnbdt5' ){
                if(e.target.value.length > 8){
                    e.target.value = e.target.value.substr(0,8);
                }else{
                    this.custInfo.chlnbdt5 = e.target.value;
                }
            }
            if(e.target.id == 'chlnnam5' ){
                if(e.target.value.length > 10){
                    e.target.value = e.target.value.substr(0,10);
                }else{
                    this.custInfo.chlnnam5 = e.target.value;
                }
            }
            if(e.target.id == 'memo' ){
                if(e.target.value.length > 500){
                    e.target.value = e.target.value.substr(0,500);
                }else{
                    this.memo = e.target.value;
                }                
                this.memoLength = e.target.value.length;
            }
            if(e.target.id == 'custbrdt' ){
                if(e.target.value.length > 8){
                    e.target.value = e.target.value.substr(0,8);
                }else{
                    this.custInfo.custbrdt = e.target.value;
                }
            }
            if(e.target.id == 'custadr2' ){
                if(e.target.value.length > 30){
                    e.target.value = e.target.value.substr(0,30);
                }else{
                    this.custInfo.custadr2 = e.target.value;
                }
            }            
        },
        goBannerPage(){ // 배너페이지 띄우기. 다 만들었는데, 사용안한다고..
            var that = this;
            
            this.$api.myCstmr.getToken()
            .then(function(res) {
                var ssoUrl = 'http://ksos.kyowon.co.kr?';
                ssoUrl += 'userId='+ res.userIdEnc+'&token=' + res.token;
                ssoUrl += '&path=' + encodeURIComponent('/pioneer/pttCstmPN');

                console.log("MyCstmrReg.vue goBannerPage ssoUrl", ssoUrl);
                
                that.$utils.nativeIf.outbound.outlink(ssoUrl);
            })
            .catch(function() {
            //alert(error.rtMsg);
            });
        },
    },
    mounted() {        
        // 저장된 무진활동 정보 조회 및 셋팅
        var todayDate = new Date();
        var todayYYYYMMDD = todayDate.getFullYear() + this.pad(todayDate.getMonth() + 1,2) + this.pad(todayDate.getDate(),2);
        
        var prensrnoinfo = this.$store.getters.prensrnoinfo;
        if(prensrnoinfo.name == 'my-cstmr-reg-default'){  
            //console.log("MyCstmrReg.vue mounted this.$store.getters.prensrnoinfo", this.$store.getters.prensrnoinfo);
            if(todayYYYYMMDD == prensrnoinfo.data.saveDate) // 같은 날짜이면 default로 무진활동을 셋팅해준다.
            {
                this.custInfo.prensrno = prensrnoinfo.data.prensrno;
                this.custInfo.custnote = prensrnoinfo.data.custnote;                
            }
        }

        var that = this;
        var params = {kwkkey:''};

        // 관심정보, 무진활동 공통코드 목록 조회
        this.$api.myCstmr.getInterestInfoList(params)
            .then(function(res) {
                //console.log("MyCstmrReg.vue mounted api.myCstmr.getInterestInfoList res", res);
                that.custInterestInfoList = res.custInterestInfoList;
                //that.$refs.custhno.focus();
            })
            .catch(function(error) {
                alert(error.rtMsg);
            });
        
        // 항목 정렬 순서 조회
        this.$api.set.getMyCstmrRegSetUserInfo({})
            .then(function (data) {
                //console.log("MyCstmrReg.vue <api.set.getMyCstmrRegSetUserInfo.response>",data);
                if(data){
                    var newSort = {};
                    var list = data;
                    for(var idx in list){
                        newSort[list[idx].itemCd] = list[idx].expoSqnc;
                    }
                    that.cardSort = newSort;
                }
                //console.log("MyCstmrReg.vue that.cardSort",that.cardSort);        
            })
            .catch(function (error) {
                alert(error.rtMsg);
            });
    },    
};
</script>
